export default "__VITE_ASSET__Cu4SCFsE__"